import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootSlice/rootSlice'
// import shopCRMeducer from './shopCRMSlice/shopCRMSlice'
// import categoryReducer from './categorySlice/categorySlice'
// import subscriptionReducer from './subSlice/subSlice'
// import registerShopReducer from './registerShopSlice/registerShopSlice'
// import scanReducer from './scanSlice/scanSlice'
// import analyticReducer from './analyticSlice/analyticSlice'
// import saleReducer from './saleSlice/saleSlice'
// import promotionSlice from './promoSlice/promoSlice'
// import employeeSlice from './employeeSlice/employeeSlice'

export const store = configureStore({
    reducer: {
        root: rootReducer,
        // shopReducer: shopCRMeducer,
        // categoryReducer: categoryReducer,
        // subscription: subscriptionReducer,
        // registerShop: registerShopReducer,
        // scanReducer: scanReducer,
        // analytics: analyticReducer,
        // sale: saleReducer,
        // promotion: promotionSlice,
        // employee: employeeSlice
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch